// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listst-full-div {
  width: 100%;
  height: 100%;
  background-color: var(--listsubtitles-backcolor);
  color: black;
  border-radius: 4px;
  overflow: hidden;
}

.listst-header-div {
  height: 35px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.listst-header-div:has(.hide){
  justify-content: center;
}

.listst-header-div .error {
  color: #ff9c9c;
  align-content: end;
}

.listst-header-div .checkbox {
  margin-left: 14px;
  height: 100%;
  align-content: end;
}

.listst-header-div .checkbox.hide {
  display: none;
}

.listst-header-div .filter {
  margin-right: 22px;
  height: 100%;
  align-content: end;
}

.listst-top-div {
  width: 100%;
  height: calc(100% - 35px);
  display: flex;
}

.listst-text-div {
  width: calc(100% - 20px); /* 20px c'est le scroll */
  height: 100%;
  background-color: transparent;
  cursor: text;
  outline: none;
}

.listst-card-div {
  margin: 10px;
  overflow: hidden;
}

.listst-scroll-div {
  height: calc(100% - 5px);
  width: 20px;
}

input[type='range'][orient='vertical'] {
  writing-mode: vertical-lr;
  direction: ltr;
  width: 16px;
  height: 100%;
  vertical-align: bottom;
}

/*.moving {
  cursor: grabbing;
}*/
`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/subtitles/list-st/edit-list-st.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,gDAAgD;EAChD,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,wBAAwB,EAAE,yBAAyB;EACnD,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;EAEE","sourcesContent":[".listst-full-div {\n  width: 100%;\n  height: 100%;\n  background-color: var(--listsubtitles-backcolor);\n  color: black;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.listst-header-div {\n  height: 35px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.listst-header-div:has(.hide){\n  justify-content: center;\n}\n\n.listst-header-div .error {\n  color: #ff9c9c;\n  align-content: end;\n}\n\n.listst-header-div .checkbox {\n  margin-left: 14px;\n  height: 100%;\n  align-content: end;\n}\n\n.listst-header-div .checkbox.hide {\n  display: none;\n}\n\n.listst-header-div .filter {\n  margin-right: 22px;\n  height: 100%;\n  align-content: end;\n}\n\n.listst-top-div {\n  width: 100%;\n  height: calc(100% - 35px);\n  display: flex;\n}\n\n.listst-text-div {\n  width: calc(100% - 20px); /* 20px c'est le scroll */\n  height: 100%;\n  background-color: transparent;\n  cursor: text;\n  outline: none;\n}\n\n.listst-card-div {\n  margin: 10px;\n  overflow: hidden;\n}\n\n.listst-scroll-div {\n  height: calc(100% - 5px);\n  width: 20px;\n}\n\ninput[type='range'][orient='vertical'] {\n  writing-mode: vertical-lr;\n  direction: ltr;\n  width: 16px;\n  height: 100%;\n  vertical-align: bottom;\n}\n\n/*.moving {\n  cursor: grabbing;\n}*/\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
